(function() {
  function handleSiblingSwatchClick(swatch) {
    const container = swatch.closest('.product-card__siblings');
    if (!container) return;

    const card = container.closest('product-card');
    if (!card) return;

    const url = swatch.dataset.siblingUrl;
    const handle = swatch.dataset.siblingHandle;
    const title = swatch.dataset.siblingTitle;
    const image = swatch.dataset.siblingImage;
    const imageAlt = swatch.dataset.siblingImageAlt;
    const secondaryImage = swatch.dataset.siblingSecondaryImage;

    const primaryImg = card.querySelector('.product-card__image--primary');
    if (primaryImg && image) {
      primaryImg.src = image;
      primaryImg.srcset = image;
      primaryImg.alt = imageAlt || title;
    }

    const secondaryImg = card.querySelector('.product-card__image--secondary');
    if (secondaryImg) {
      if (secondaryImage) {
        secondaryImg.src = secondaryImage;
        secondaryImg.srcset = secondaryImage;
        secondaryImg.style.display = '';
      } else {
        secondaryImg.style.display = 'none';
      }
    }

    const titleEl = card.querySelector('.product-title');
    if (titleEl && title) {
      titleEl.textContent = title;
    }

    card.querySelectorAll('a[href]').forEach(function(link) {
      if (
        link.dataset.productCardMediaLink !== undefined ||
        link.classList.contains('product-title')
      ) {
        link.href = url;
      }
    });

    container.querySelectorAll('.product-card__sibling-swatch').forEach(function(s) {
      s.classList.remove('is-active');
    });
    swatch.classList.add('is-active');

    const sizesContainer = card.querySelector('.product-card__sizes');
    if (sizesContainer && handle) {
      fetch('/products/' + handle + '?section_id=product-card-sizes', {
        headers: { 'Accept': 'text/html' }
      })
        .then(function(response) {
          if (!response.ok) return;
          return response.text();
        })
        .then(function(html) {
  if (!html) return;
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const newSizes = doc.querySelector('.product-card__sizes');

  if (newSizes) {
    sizesContainer.replaceWith(newSizes);

    if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
  }
})
        .catch(function() {});
    }

    const quickBuyModal = card.querySelector('.quick-buy-modal');
    if (quickBuyModal && handle) {
      quickBuyModal.setAttribute('handle', handle);
    }
  }

  function initSiblingSwatches(scope) {
    // Intentionally left minimal.
    // Collection card sibling swatches now use delegated click handling below,
    // so they continue working on paginated / instant-loaded collection pages.
  }

  function initQuickBuySiblingSwatches(scope) {
    const root = scope || document;

    root.querySelectorAll('[data-quick-buy-sibling]').forEach(function(swatch) {
      if (swatch.dataset.quickBuyBound === 'true') return;
      swatch.dataset.quickBuyBound = 'true';

      swatch.addEventListener('click', function(e) {
        e.preventDefault();

        const handle = swatch.dataset.siblingHandle;
        if (!handle) return;

        const quickBuyModal = swatch.closest('.quick-buy-modal');
        if (!quickBuyModal) return;

        const modalContent = quickBuyModal.querySelector('.quick-buy-modal__content');
        if (!modalContent) return;

        quickBuyModal.classList.add('is-loading');
        swatch.disabled = true;

        fetch('/products/' + handle, {
          headers: { 'Accept': 'text/html' }
        })
          .then(function(response) {
            if (!response.ok) {
              throw new Error('Failed to load sibling product');
            }
            return response.text();
          })
          .then(function(html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newTemplate = doc.querySelector('#quick-buy-content');

            if (!newTemplate) {
              throw new Error('Quick buy template not found on sibling product page');
            }

            const wrapper = document.createElement('div');
            wrapper.innerHTML = newTemplate.innerHTML;

            const newModalContent = wrapper.querySelector('.quick-buy-modal__content');
            if (!newModalContent) {
              throw new Error('Quick buy modal content not found');
            }

            modalContent.innerHTML = newModalContent.innerHTML;

            quickBuyModal.setAttribute('handle', handle);

            initSiblingSwatches(quickBuyModal);
            initQuickBuySiblingSwatches(quickBuyModal);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
          })
          .catch(function(error) {
            console.error(error);
          })
          .finally(function() {
            quickBuyModal.classList.remove('is-loading');
            swatch.disabled = false;
          });
      });
    });
  }

  function initAll(scope) {
    initSiblingSwatches(scope);
    initQuickBuySiblingSwatches(scope);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });

  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('.product-card__sibling-swatch');
    if (swatch) {
      e.preventDefault();
      handleSiblingSwatchClick(swatch);
      return;
    }

    const modal = e.target.closest('.quick-buy-modal');
    if (modal) {
      initAll(modal);
    }
  });
})();